import { useEffect } from "react";
import { Description, Title, TitlePrivacy } from "./GeneralConditions.styled";
import { handleScrollUp } from "../utils/helpers";
import { Helmet } from "react-helmet-async";
import { META_DATA } from "../utils/constants";

const GeneralConditions = () => {

    const { title, description, keywords } = META_DATA?.privacyPolicy;

    useEffect(() => {
        handleScrollUp(); 
    }, [])

    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="keywords" content={keywords} />                
                <meta name="description" content={description} />
            </Helmet>
        <div>
            <TitlePrivacy>Informativa sulla Privacy di mathlab.it</TitlePrivacy>
            <Title>Introduzione</Title>
            <Description>
                Questa informativa sulla privacy descrive come raccogliamo, utilizziamo e
                proteggiamo i dati personali degli utenti di mathlab.it.
                Ci impegniamo a garantire che la privacy dei nostri utenti{/* , in particolare
                dei minori, sia rispettata e protetta */}.
            </Description>
            <Title>Dati Raccolti</Title>
            <Description>
                Raccogliamo i seguenti dati personali dagli utenti: nome, cognome, email e ruolo
                (insegnante o alunno). All'interno delle classroom, gli insegnanti possono visualizzare
                i nomi, i cognomi degli alunni e i risultati dei quiz, mentre gli alunni possono vedere i nomi,
                i cognomi e i risultati dei propri compagni appartenenti alla stessa classroom.
            </Description>
            <Title>Utilizzo dei Dati</Title>
            <Description>
                I dati raccolti vengono utilizzati per i seguenti scopi: autenticazione - utilizziamo
                i cookie, strettamente necessari per l'autenticazione degli utenti; miglioramento
                dell'esperienza dell'utente - utilizziamo nome, cognome, email e ruolo per personalizzare
                e migliorare l'esperienza degli utenti all'interno della web app; visibilità dei dati -
                all'interno delle classroom, gli insegnanti hanno la possibilità di visualizzare i nomi,
                i cognomi e i risultati dei quiz degli alunni. Gli alunni, a loro volta, possono vedere i
                nomi, i cognomi e i risultati dei propri compagni appartenenti alla stessa classroom,
                favorendo un ambiente di apprendimento collaborativo.
            </Description>
            <Title>Memorizzazione dei Dati</Title>
            <Description>
                I dati personali degli utenti vengono memorizzati in un database, garantendo
                un'adeguata sicurezza e protezione delle informazioni.
            </Description>
            <Title>Accesso ai Dati</Title>
            <Description>
                Solo il titolare di mathlab.it, gli insegnanti e gli alunni della stessa classroom hanno
                accesso ai dati personali raccolti. In particolare, gli insegnanti possono visualizzare i
                nomi e i risultati dei quiz degli alunni iscritti nelle loro classroom. Non condividiamo i
                dati con terze parti, salvo obblighi legali.
            </Description>
            <Title>Diritti degli Utenti</Title>
            <Description>
                Accedere ai propri dati personali, richiedere la rettifica o cancellazione dei dati.
            </Description>            
            <Title>Conservazione dei Dati</Title>
            <Description>
                I dati personali saranno conservati per il tempo necessario a fornire i servizi della web app.
                Gli utenti possono richiedere la cancellazione dei propri dati in qualsiasi momento.
            </Description>
            <Title>Contatti</Title>
            <Description>
                Per domande riguardanti i dati personali o questa informativa sulla privacy, gli
                utenti possono contattarci all'indirizzo email: info@mathlab.it.
            </Description>
            <Title>Modifiche all'Informativa sulla Privacy</Title>
            <Description>
                Ci riserviamo il diritto di modificare questa informativa in qualsiasi momento. Gli utenti
                saranno informati di eventuali modifiche tramite un avviso pubblicato sul sito o via email.
            </Description>


            <h2>Consenso all'uso dei Cookie</h2>
            <Title>Utilizzo dei Cookie</Title>
            <Description>                
                Su mathlab.it utilizziamo solo cookie tecnici necessari per l’autenticazione e la gestione della
                sessione utente. Questi cookie includono: authToken (memorizza il token di autenticazione per
                accedere in modo sicuro al proprio account), refreshToken (consente di mantenere la sessione
                attiva e di accedere senza dover rieffettuare il login). Entrambi i cookie sono essenziali per il
                corretto funzionamento della piattaforma e non vengono utilizzati per scopi di profilazione o marketing.
                Non è possibile disattivare questi cookie se si desidera utilizzare i servizi autenticati di mathlab.it.
            </Description>
            <Title>Consenso al Trattamento dei Dati e all'Uso dei Cookie</Title>
            <Description>
                l momento della registrazione, ti verrà richiesto di fornire il consenso al trattamento dei tuoi dati personali
                e all'uso dei cookie per finalità di autenticazione. Inoltre, i genitori dovranno confermare di aver letto e
                accettato le condizioni relative alla visibilità dei dati all'interno della classroom.
            </Description>
            <h2>Sostienici</h2>
            <Title>Supporto tramite link affiliati</Title>
            <Description>
                Alcune pagine di mathlab.it possono contenere link affiliati Amazon.
                Se scegli di acquistare un prodotto tramite questi link, per te non ci saranno costi aggiuntivi.
                Il tuo acquisto rappresenta un piccolo gesto di sostegno che aiuta a mantenere mathlab.it gratuita e accessibile per tutti.
            </Description>
        </div>
        </>
    )
};

export default GeneralConditions;